// 앱 floor(macOS 11.3 = Safari 14.1)에 없는 런타임 API 폴리필. build.target 은 문법만 다운레벨하고
// 런타임 API 는 못 막는다 → 여기서 가드형으로 보강한다. main.tsx 의 첫 import 여야 한다.
// Object.hasOwn — Safari 15.4+. react-virtuoso dist 가 사용(빌드 산출물 정적 검사로 확인).
if (typeof Object.hasOwn !== "function") {
  Object.defineProperty(Object, "hasOwn", {
    value: (target: object, key: PropertyKey): boolean =>
      Object.prototype.hasOwnProperty.call(target, key),
    configurable: true,
    writable: true,
  });
}

export {};
